export default "__VITE_ASSET__Cka1bM6Z__"